import React from 'react';
import { useHistory } from 'react-router-dom';
import { IconButton, Button, Container, Heading, Stack, Text } from '@guestyci/arc';
import t from '@guestyci/localize/t.macro';
import { utils } from 'utils';

import { Unplug } from '@guestyci/icons/system';

import { useBreakpoint } from '../../utils/useBreakpoint';
import guestyLogo from '../../assets/guesty-logo-dark-blue.svg';
import HelpButton from '../components/HelpButton';

const LinkExpiredPage = () => {
  const history = useHistory();
  const isDesktop = useBreakpoint('md');

  utils.useDocumentTitle('Link Expired');
  utils.usePageView('link-expired');

  const handleResetPassword = () => {
    history.push('/forgot');
  };

  return (
    <Container
      maxWidth="full"
      gutter={0}
      className="gst-min-h-screen gst-bg-white gst-flex gst-flex-col"
    >
      <Stack
        direction="row"
        align="center"
        justify="between"
        className="gst-px-10 gst-py-6"
      >
        <img src={guestyLogo} alt="Guesty" />
        <HelpButton />
      </Stack>

      <Stack
        spacing={0}
        align="center"
        justify="center"
        className="gst-flex-1 gst-px-5"
      >
        <Stack spacing={6} align="center" className="gst-text-center gst-max-w-[379px]">
          <IconButton size="lg" disabled className="gst-w-16 gst-h-16 disabled:gst-opacity-100">
            <Unplug />
          </IconButton>
          <Stack spacing={4} align="center">
            <Heading variant="h1">
              {t('This link is expired or has already been used')}
            </Heading>
            <Text size={isDesktop ? 'lg' : 'base'} className="gst-text-muted-foreground">
              {t('Reset your password to receive a new link.')}
            </Text>
          </Stack>

          <Button onClick={handleResetPassword}>
            {t('Reset password')}
          </Button>
        </Stack>
      </Stack>
    </Container>
  );
};

export default LinkExpiredPage;
